import { Component, Input, OnInit } from '@angular/core';
import { ToastService } from 'src/app/services/toast/toast.service';
import { EventService } from 'src/app/_services/event.service';
import { ApiService } from 'src/app/_services/api.service';
import { Router } from '@angular/router';
import { SearchEventModel } from "../../../_models/Event/SearchEventModel";
import { EventStatusEnum } from "../../../_models/Enums/EventStatusEnum";

@Component({
  selector: 'app-event-item',
  templateUrl: './event-item.component.html',
  styleUrls: ['./event-item.component.scss']
})
export class EventItemComponent implements OnInit {

  @Input() event?: any;
  loadingPage: Boolean = false;
  eventSearchModel: SearchEventModel = new SearchEventModel();

  constructor(
    private toastMessagesService: ToastService,
    private eventService: EventService,
    private apiService: ApiService,
    private router: Router,
    ) { }

  ngOnInit(): void {
    this.eventSearchModel.status = +EventStatusEnum[this.event.status];
  }

  onPublish(eventId:string){
    this.loadingPage = true;
    this.apiService.publishEvent(eventId).subscribe(()=>{
      this.apiService.getEvents(this.eventSearchModel).subscribe();
      this.loadingPage = false;
    });
  }

  onManage(eventId:string){
    // console.log(eventId);
    this.router.navigateByUrl(`/promoter/event-manager/${eventId}`);
  }

  onCancel(eventId:string){
    // console.log(eventId)
    this.loadingPage = true;
    this.apiService.cancelEvent(eventId).subscribe(()=>{
      this.apiService.getEvents(this.eventSearchModel).subscribe();
      this.loadingPage = false;
    });
  }

  onOpen(eventId: string){
    this.router.navigateByUrl(`/promoter/event-manager/${eventId}`);
  }

  onDelete(eventId: string){
    this.loadingPage = true;
    this.apiService.deleteEvent(eventId).subscribe(() => {
      this.apiService.getEvents(this.eventSearchModel).subscribe();
      this.loadingPage = false;
    })
  }

  onSuccess(): void {
    this.toastMessagesService.nextToastMessage({
      severity:'success',
      summary: 'Success',
      detail: 'Event has been successfully published'
    });
  }

  onError(): void {
    this.toastMessagesService.nextToastMessage({
      severity:'error',
      summary: 'Error',
      detail: 'There are some problems'
    });
  }

}
